module.exports = __webpack_public_path__ + "282cd4a7baa4220002fe1cbb2d37cec7.svg";